export enum PriceLabelStyleType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LIGHTEN = 'lighten',
  CAMPAIGN = 'campaign',
}

export type priceLabelStylingType =
  | PriceLabelStyleType.PRIMARY
  | PriceLabelStyleType.SECONDARY
  | PriceLabelStyleType.LIGHTEN
  | PriceLabelStyleType.CAMPAIGN;
